/**
 * Linear interpolation
 *
 * Example:
 * lerp(0,10,0.5) => 5
 * lerp(65,84,0.5) => 74.5
 *
 * @param {Number} min The "minimum" output value
 * @param {Number} max The "maximum" output value
 * @param {Number} x The input value to interpolate
 * @param {Boolean} clamp Clamp the output between the min and max value
 * @return the interpolated value
 */
export function lerp(min, max, x, clamp = false) {
  if (clamp) {
    if (x < 0) {
      return min;
    }
    if (x > 1) {
      return max;
    }
  }
  return x * (max - min) + min;
}

/**
 * Reversed linear interpolation
 *
 * Example:
 * unlerp(0,10,5) => 0.5
 * unlerp(87,167,127) => 0.5
 *
 * @param {Number} min The "minimum" input value
 * @param {Number} max The "maximum" input value
 * @param {Number} x The input value to unlerp
 * @param {Boolean} clamp Clamp the output between the min and max value
 * @return the reverse interpolated value
 */
export function unlerp(min, max, x, clamp = false) {
  if (clamp) {
    if (x < min) {
      return 0;
    }
    if (x > max) {
      return 1;
    }
  }
  return (x - min) / (max - min);
}
